import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { ButtonGroup, Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexRow, HTMLViewer } from './Styles/HTMLViewerDialogBox';

const HTMLViewerDialogBox = ({ open, text, onTrue, onFalse, ...props }) => {
	const onTrueHandler = async () => {
		onTrue();
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {}, [open, text]);

	return (
		<Dialog
			open={open}
			onClose={() => onFalseHandler()}
			fullWidth
		>
			<DialogTitle>
				HTML Viewer
			</DialogTitle>

			<DialogContent style={{ marginTop: '-16px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>
					<HTMLViewer text={text} />
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						secondary
						outline
						onClick={() => onFalseHandler()}
					>
						Close
					</Button>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {};

export default connect(mapStatesToProps, mapFunctionsToProps)(HTMLViewerDialogBox);
